import { render, staticRenderFns } from "./InformationCard.vue?vue&type=template&id=41060482&"
import script from "./InformationCard.vue?vue&type=script&lang=js&"
export * from "./InformationCard.vue?vue&type=script&lang=js&"
import style0 from "./InformationCard.vue?vue&type=style&index=0&id=41060482&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports